@if (tip) {
    <article class="flex items-center gap-16">
        @switch (tip.severity) {
            @case (TipSeverity.SUCCESS) {
                <interacta-icon
                    class="size-24 shrink-0 text-system-success"
                    [icon]="'check'"
                />
            }
            @case (TipSeverity.INFO) {
                <interacta-icon
                    class="size-24 shrink-0 text-text-link"
                    [icon]="'info'"
                />
            }
            @case (TipSeverity.WARN) {
                <interacta-icon
                    class="size-24 shrink-0 text-system-warning"
                    [icon]="'warning'"
                />
            }
            @case (TipSeverity.ERROR) {
                <interacta-icon
                    class="size-24 shrink-0 text-text-error"
                    [icon]="'warning'"
                />
            }
        }

        @if (tip.message | apply: asString; as message) {
            <div
                class="overflow-auto typo-sm wrap-break-word whitespace-pre-line text-text"
                [innerHTML]="message | translate: tip.translateParams"
            ></div>
        } @else if (tip.message | apply: asDelta; as deltaMessage) {
            <interacta-delta-view
                class="min-w-0 typo-sm text-text"
                [delta]="deltaMessage"
                [iconSize]="'small'"
            />
        }

        @if (tip.closeBehavior === 'reload') {
            <button
                class="ml-auto shrink-0"
                interacta-dialog-button
                type="button"
                [label]="'SHARED.TIPS.FORCE_RELOAD' | translate"
                [style]="'text-primary'"
                (click)="reload.emit()"
            ></button>
        }
        <button
            class="ml-auto shrink-0 text-text"
            interacta-icon-button
            type="button"
            [icon]="'close'"
            [label]="'UI.BUTTON.CLOSE' | translate"
            [size]="'regular'"
            [style]="'text'"
            [tooltipClass]="'tooltip-reverse-theme'"
            (click)="closeTip.emit()"
        ></button>
    </article>
}
